<!--
 - @author: linwen linwen@fjxhx.com.
 - @createDate: 2020-12-21 16:03.
 - @file: 明厨亮灶.
 - @copyRight © 2020年 新和兴.All rights reserved.
-->
<template>
  <div class="mingChu">
    <div class="mingChu-bg"></div>
    <div class="ming-wrap">
      <div class="ming-wrap-left">
        <!--安全综合评估-->
        <safe @changeValFnc="changeValFnc"></safe>
        <!--异常处置情况-->
        <ycDeal :selectDeptId="selectDeptId"></ycDeal>
        <!--最新预警-->
        <news :selectDeptId="selectDeptId"></news>
        <!--日巡查清单-->
        <dailyList :selectDeptId="selectDeptId"></dailyList>
      </div>
      <div class="ming-wrap-center">
        <div class="video-list">
          <video-swiper :list="list" :isCutDept="isCutDept" @childChangeDept="childChangeDept"></video-swiper>
        </div>
      </div>
      <div class="ming-wrap-right">
        <!--食堂负责人-->
        <leader :selectDeptId="selectDeptId"></leader>
        <!--体温异常人员-->
        <abnormalTemperature :selectDeptId="selectDeptId"></abnormalTemperature>
        <!--健康证到期人员预警-->
        <overduePerson :selectDeptId="selectDeptId"></overduePerson>
        <!--承包商公示-->
        <contractor :selectDeptId="selectDeptId"></contractor>
      </div>
    </div>
  </div>
</template>

<script>
  import safe from '../components/mingChu/safe'//安全综合评估
  import ycDeal from '../components/mingChu/ycDeal'//异常处置情况
  import news from '../components/mingChu/news'//最新预警
  import dailyList from '../components/mingChu/dailyList' //最新预警
  import leader from '../components/mingChu/leader' //食堂负责人
  import abnormalTemperature from '../components/mingChu/abnormalTemperature' // 体温异常人员
  import overduePerson from '../components/mingChu/overduePerson' //健康证到期人员预警
  import contractor from '../components/mingChu/contractor' //承包商公示
  import VideoSwiper from '../components/VideoSwiper/VideoSwiper'; // 监控轮播
export default {
  name: 'mingChu',
  components: { VideoSwiper,safe,ycDeal,news,dailyList,leader,abnormalTemperature,overduePerson,contractor },
  data () {
    return {
      orgId: this.$store.getters.userInfo.orgId,
      selectDeptId: '',
      urlExpireTime: 0, // 萤石云过期时间
      list: new Array(4).fill({}),
      cameraData: [],
      isCutDept:false // 切换食堂
    }
  },
  mounted() {
    this.getCanteenList()
    this.mCWebsocketMsg()
  },
  destroyed() {
    // 页面切换循环销毁hls视频播放实例
    for (let i = 0; i < this.list.length; i++) {
      this.list[i].hls && this.list[i].hls.destroy()
    }
  },
  methods: {
    /**
     * 获取websocket推送信息
     * @author wanghongling
     * @createTime 2020/12/24
     */
    mCWebsocketMsg () {
      window.webSocket.onmessage = e => {
        if (e.data === 'heartbeat') return
        let data = JSON.parse(e.data)
        switch (data.type) {
          case 'szsa-mclz':
            window.getSafeInfo()
            window.getDealInfo()
            window.getNewsInfo()
            window.getDailyInfo()
            window.getLeaderInfo()
            window.getTemperatureInfo()
            window.getHealthInfo()
            window.contractorWsMsg()
            break
          default:
            break
        }
      }
    },
    childChangeDept(val){
      console.log('mingchu isCutDept val,',val)
      this.isCutDept = val
    },
    /**
     * @Description:切换食堂
     * @author wanghongling
     * @createDate 2020/12/23
    */
    changeValFnc(e) {
      this.selectDeptId = e
      console.log(`获取切换的食堂的值：`, this.selectDeptId)
      this.isCutDept=true
      setTimeout(()=>{
        this.getVideoSwiperList(this.selectDeptId)
      },1000);
    },
    /**
     * @description: 获取监控轮播列表数据(并拼接成可播放的url)
     * @author: linwen linwen@fjxhx.com
     * @createDate: 2020-12-23 16:15
     */
    async getVideoSwiperList(selectDeptId) {
      this.data = []
      this.list.length = 0
      await this.getCameraHls(selectDeptId)
      await this.setHlsList()
    },
    /**
     * @description: 获取监控轮播列表数据(并拼接成可播放的url)
     * @author: wuzp wuzp@fjxhx.com
     * @createDate: 2021-10-14 16:15
     */
    async getCameraHls(selectDeptId) {
      let that = this
      let params = { departmentId: selectDeptId }
      await this.$request.cameraConfigByRoleListGet(params).then( res => {
        console.log('res______________', res)
        that.data = res
      })
    },
    /**
     * @description: 设置播放链接
     * @author: wuzp wuzp@fjxhx.com
     * @createDate: 2021-10-14 16:15
     */
    setHlsList() {
      if (this.urlExpireTime > 0) {
        let _this = this
        setTimeout(function () {
          _this.getVideoSwiperList(_this.selectDeptId)
        },  _this.urlExpireTime)
      }
      switch (this.data.length % 4) {
        case 1:
          this.data.push({},{},{})
          break
        case 2:
          this.data.push({},{})
          break
        case 3:
          this.data.push({})
          break
        default:
          this.list = this.data
      }
      //console.log('444data',this.data)
      this.list = this.data
      if(this.list.length === 0){
        this.list = new Array(4).fill({})
      }
      //console.log('++++++++++++处理this.list+++++++++++++++++', this.list)
    },
    /**
     * @Description:获取名厨亮灶食堂列表
     * @author wanghongling
     * @createDate 2020/12/24
     */
    getCanteenList() {
      return this.$request.constramanageDeptOrgListGet({orgId: this.orgId}).then(async res => {
        //console.log(`获取名厨亮灶食堂列表:`, res)
        if(!this.$utils.isEmptyObject(res)) {
          this.selectDeptId = res[0].departmentId
          await this.getVideoSwiperList(this.selectDeptId)
        }
      }).catch(e => {
        console.error(e)
      })
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
  .mingChu{
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    .layer-wrap{
      margin-bottom: 10px;
      min-width: 230px;
    }
    .ming-wrap{
      display: flex;
      justify-content: space-between;
      padding: 100px 15px 20px;
      &-left{}
      &-center{
      }
      &-right{}
    }


    .mingChu-bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 85px;
      background: url('../assets/images/index/top.png') no-repeat;
      background-size: cover;
      z-index: 12;
    }
  }
.video-list {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/mingChu.vue